module.exports = __webpack_public_path__ + "static/img/default_image_02@3x.86f3195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/default_image_02@3x.png
// module id = klBX
// module chunks = 2